const NANOSECONDS_IN_MILLISECONDS = 1000000;
function millisecondsToNanoseconds(milliseconds) {
    return Math.round(milliseconds * NANOSECONDS_IN_MILLISECONDS);
}

export { millisecondsToNanoseconds };
